function getFileName(url: string) {
  if (url) {
    return url.substring(url.lastIndexOf('/') + 1);
  }
  return '';
}

export default getFileName;
